export default __webpack_public_path__ + "static/3-907db7e2fbf4811ceb8b35b363ebe924.jpeg";